import React from 'react';

const LoadingSpinner = () => (
  <div className="loading-wrapper loading-wrapper--spacing">
    <span className="loading-spinner">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#F1F1F1"
            d="M20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 Z M20,36.6666667 C29.2047458,36.6666667 36.6666667,29.2047458 36.6666667,20 C36.6666667,10.7952542 29.2047458,3.33333333 20,3.33333333 C10.7952542,3.33333333 3.33333333,10.7952542 3.33333333,20 C3.33333333,29.2047458 10.7952542,36.6666667 20,36.6666667 Z"
          />
          <path
            className="loadingCircle-colorSection"
            fill="#0056C9"
            fillRule="nonzero"
            d="M20,0 C8.954305,0 0,8.954305 0,20 C0,20.9204746 0.746192084,21.6666667 1.66666667,21.6666667 C2.58714125,21.6666667 3.33333333,20.9204746 3.33333333,20 C3.33333333,10.7952542 10.7952542,3.33333333 20,3.33333333 C20.9204746,3.33333333 21.6666667,2.58714125 21.6666667,1.66666667 C21.6666667,0.746192084 20.9204746,0 20,0 Z"
          />
        </g>
      </svg>
    </span>
  </div>
);

export default LoadingSpinner;
